import CompanyAccountCreate from '@containers/account/CompanyAccountCreate';

const CompanyAccountCreatePage = () => {
  return <CompanyAccountCreate />;
};

export default CompanyAccountCreatePage;
